import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetInboxThread as GetInboxThreadQuery,
    GetInboxThreadVariables as GetInboxThreadQueryVariables,
} from 'nutshell-graphql-types';

import GET_THREAD from '../queries/get-inbox-thread.graphql';

export const useGetInboxThreadById = (threadId?: string | null) => {
    const {
        data,
        error,
        loading: isLoading,
        refetch,
    } = useQuery<GetInboxThreadQuery, GetInboxThreadQueryVariables>(GET_THREAD, {
        skip: !threadId,
        // @ts-expect-error
        variables: {threadId},
    });

    const inboxThread = data ? data.inboxThread : null;

    return {
        thread: inboxThread,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
        refetch,
    };
};
